import * as React from "react"

function SvgFileDouble(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 40 48"
      {...props}
    >
      <g
        fill="none"
        fillRule="evenodd"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
      >
        <path d="M30.172 1c.53 0 1.04.21 1.414.586l6.828 6.828c.376.374.586.884.586 1.414V39a2 2 0 01-2 2H9a2 2 0 01-2-2V3a2 2 0 012-2h21.172z" />
        <path d="M33 41v4a2 2 0 01-2 2H3a2 2 0 01-2-2V9a2 2 0 012-2h4" />
      </g>
    </svg>
  )
}

export default SvgFileDouble
